/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 17/03/22
 */

import React, { useState } from 'react';
import { Box, Stack } from '@chakra-ui/react';
import LocalAdminEditor from '@/components/pages/Admin/LocalAdmin/LocalAdminEditor';
import FacultyPicker from '@/components/pages/Admin/Pickers/FacultyPicker';
import { Assignment } from '@/wpt-lib/interfaces/Assignment';
import OrganisationPicker from '@/components/pages/Admin/Pickers/OrganisationPicker';
import DownloadFile from '@/components/DownloadFile';

export const LocalAdminPanel = ({ assignment }: { assignment: Assignment }) => {
    const [facultyId, setFacultyId] = useState<number>();
    const [orgId, setOrgId] = useState<number>();

    return (
        <Stack gap={3}>
            <Stack
                direction={{ base: 'column', md: 'row' }}
                alignItems="flex-start"
                justifyContent={{ base: 'center', md: 'flex-start' }}
                spacing={4}
            >
                <FacultyPicker assignment={assignment} facultyId={facultyId} setFacultyId={setFacultyId} />
                {facultyId && (
                    <OrganisationPicker
                        label="Organisation Unit"
                        assignment={assignment}
                        organisationId={orgId}
                        facultyId={facultyId}
                        setOrganisationId={setOrgId}
                        all
                    />
                )}

                <Box style={{ marginLeft: 'auto ' }}>
                    <DownloadFile label="Download Local Area Admins" path="/excel/downloadLocalAdminReport" />
                </Box>
            </Stack>
            {facultyId && (
                <>{assignment.isGlobalAdmin && <LocalAdminEditor facultyId={facultyId} organisationId={orgId} />}</>
            )}
        </Stack>
    );
};
